import React, { FC, useState } from "react";
import { Slider, Box } from "@mui/material";
import { connect } from "react-redux";
import { setBrushSize } from "../../../state/actions";

const wrapperStyles = {
  marginBottom: "8px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  cursor: "pointer",
  color: "#5d5e5e",
  zIndex: "1000",
  userSelect: "none",
  "@media (max-width: 900px)": {
    transform: "scale(0.9)",
  },
};
const sliderStyles = {
  color: "#000",
  height: "180px",
  "& .MuiSlider-thumb": {
    height: "18px",
    width: "18px",
    "&:hover, &.Mui-focusVisible": {
      boxShadow: `0px 0px 0px 4.5px rgba(0, 0, 0, 0.16)`,
    },
    "&.Mui-active": {
      boxShadow: `0px 0px 0px 7.5px rgba(0, 0, 0, 0.16)`,
    },
  },
  "@media (max-width: 900px)": {
    transform: "scale(0.9)",
  },
};

type Props = {
  brushSize?: number;
  handleBrushSizeChange: (value: number) => void;
  setBrushSize: (payload: number) => void;
};

const CanvasBrushSizeSlider: FC<Props & any> = ({
  handleBrushSizeChange,
  setBrushSize,
  brushSize,
}) => {
  const [initialBrushSize] = useState(brushSize);
  const minSize = initialBrushSize * 0.3;
  const maxSize = initialBrushSize * 2;
  return (
    <Box sx={wrapperStyles}>
      <Slider
        orientation="vertical"
        sx={sliderStyles}
        defaultValue={initialBrushSize}
        step={minSize}
        min={minSize}
        max={maxSize}
        onChange={(e: Event) => {
          const brushSize = parseFloat((e.target as HTMLInputElement).value);
          handleBrushSizeChange(brushSize);
          setBrushSize(brushSize);
        }}
      />
      <Box></Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  const { brushSize } = state;
  return {
    brushSize,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setBrushSize: (payload) => dispatch(setBrushSize(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CanvasBrushSizeSlider);
